import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-up-down-icon',
  templateUrl: './navigation-up-down.component.html'
})
export class NavigationUpDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
